import React from 'react';
import { Link } from 'react-router-dom';

const APP_VERSION = "5.25.18";

/**
 * Shared Footer Component
 * 
 * Variants:
 * - "full" (default): Logo, links, copyright - for main pages
 * - "minimal": Just logo and CTA - for browse/search pages
 * - "simple": Copyright and links only - for policy pages
 */
export const Footer = ({ variant = "full", className = "" }) => {
  const currentYear = new Date().getFullYear();

  // Minimal footer for browse/search pages
  if (variant === "minimal") {
    return (
      <footer className={`text-center pt-8 mt-8 border-t border-[#e0e0e0] ${className}`}>
        <Link 
          to="/" 
          className="text-lg font-serif font-black tracking-tight text-[#999] hover:text-[#0a0a0a] transition-colors"
        >
          besume
        </Link>
        <p className="text-xs text-[#999] mt-2">
          <Link to="/signup" className="hover:underline">Create your own Besume</Link>
        </p>
      </footer>
    );
  }

  // Simple footer for policy pages (Terms, Privacy, DMCA, Acceptable Use)
  if (variant === "simple") {
    return (
      <footer className={`border-t border-[#e0e0e0] py-8 px-6 bg-white ${className}`}>
        <div className="max-w-3xl mx-auto text-sm text-[#999] flex flex-col sm:flex-row items-center justify-between gap-4">
          <span>© {currentYear} Besume LLC · V{APP_VERSION}</span>
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <Link to="/terms" className="hover:text-[#0a0a0a]">Terms</Link>
            <span>·</span>
            <Link to="/privacy" className="hover:text-[#0a0a0a]">Privacy</Link>
            <span>·</span>
            <Link to="/acceptable-use" className="hover:text-[#0a0a0a]">Acceptable Use</Link>
            <span>·</span>
            <Link to="/dmca" className="hover:text-[#0a0a0a]">DMCA</Link>
            <span>·</span>
            <Link to="/support" className="hover:text-[#0a0a0a]">Support</Link>
          </div>
        </div>
      </footer>
    );
  }

  // Full footer (default) - for Landing, FAQ, etc.
  return (
    <footer className={`border-t border-[#e0e0e0] ${className}`}>
      <div className="max-w-5xl mx-auto px-6 py-8">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <Link to="/" className="font-serif text-2xl font-black text-[#0a0a0a]">
            besume
          </Link>
          <div className="flex flex-wrap items-center gap-4 text-sm text-[#999]">
            <Link to="/terms" className="hover:text-[#0a0a0a]">Terms</Link>
            <span className="text-[#ccc]">·</span>
            <Link to="/privacy" className="hover:text-[#0a0a0a]">Privacy</Link>
            <span className="text-[#ccc]">·</span>
            <Link to="/acceptable-use" className="hover:text-[#0a0a0a]">Acceptable Use</Link>
            <span className="text-[#ccc]">·</span>
            <Link to="/faq" className="hover:text-[#0a0a0a]">FAQ</Link>
            <span className="text-[#ccc]">·</span>
            <Link to="/support" className="hover:text-[#0a0a0a]">Support</Link>
            <span className="text-[#ccc]">·</span>
            <a href="mailto:hello@besume.com" className="hover:text-[#0a0a0a]">Contact</a>
          </div>
        </div>
        <div className="mt-6 pt-6 border-t border-[#e0e0e0] text-sm text-[#999]">
          <span>© {currentYear} Besume LLC · V{APP_VERSION}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
